import { useState } from 'react';

import AccordionItem from '../components/ui/Accordion';
import Button from '../components/ui/Button';
import Reveal from '../components/ui/Reveal';
import { Section, SectionHeading } from '../components/ui/Section';
import { faqSections } from '../data/faqData';
import { whatsappLink } from '../config/site';

export default function FAQ() {
    // First question of the first group starts open, as a hint that the rows
    // are expandable.
    const [openKey, setOpenKey] = useState('0-0');

    return (
        <Section id="faq">
            <SectionHeading
                eyebrow="Centre d'aide"
                title="Questions fréquentes"
                description="Les réponses aux points qui reviennent le plus souvent avant une première commande."
            />

            <div className="mx-auto max-w-3xl space-y-8">
                {faqSections.map((section, sectionIndex) => (
                    <Reveal key={section.category} delay={sectionIndex * 80}>
                        <div className="rounded-2xl border border-line bg-surface-raised/60 p-6 sm:p-8">
                            <h3 className="mb-2 flex items-center gap-3 text-sm font-bold uppercase tracking-[0.12em] text-brand">
                                <span className="h-4 w-1 rounded-full bg-brand" aria-hidden="true" />
                                {section.category}
                            </h3>

                            <div>
                                {section.questions.map((item, itemIndex) => {
                                    const key = `${sectionIndex}-${itemIndex}`;
                                    return (
                                        <AccordionItem
                                            key={key}
                                            question={item.question}
                                            answer={item.answer}
                                            isOpen={openKey === key}
                                            onToggle={() => setOpenKey(openKey === key ? null : key)}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={240} className="mt-12 text-center">
                <p className="text-content-muted">Votre question n'est pas dans la liste ?</p>
                <Button
                    href={whatsappLink('Bonjour, j\'ai une question avant de commander.')}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="outline"
                    className="mt-4"
                >
                    Poser une question au support
                </Button>
            </Reveal>
        </Section>
    );
}
